import { GetterTree } from 'vuex';
import { StateInterface } from '../index';
import { AppInterface } from './state';

const getters: GetterTree<AppInterface, StateInterface> = {
  getUndefinedServerError(state: AppInterface) {
    return state.isUndefinedServerError;
  },
  user(state: AppInterface) {
    return state.user;
  },
  host(state: AppInterface) {
    return state.host;
  },
  isLogged(state: AppInterface) {
    return state.user !== null;
  },
  isLeftDrawerOpen(state: AppInterface) {
    return state.isLeftDrawerOpen;
  }
};

export default getters;

